import * as React from 'react';

import { motion } from 'framer-motion';
import Hint, { HintProps } from '@components/basics/hint';
import { easeTransition } from '@components/framer';
import styled from 'styled-components';

interface AnimatedHintCtrlProps extends HintProps {
  className?: string;
  noMargin?: boolean;
}

const AnimatedHintCtrl: React.FC<AnimatedHintCtrlProps> = ({
  className,
  children,
  noMargin,
  ...props
}) => {
  const variants = {
    hidden: { opacity: 0, y: -100, marginTop: 0 },
    visible: {
      opacity: 1,
      y: 0,
      marginTop: noMargin ? '0' : '10px',
      transition: {
        ...easeTransition,
      },
    },
  };

  return (
    <motion.div
      className={className}
      initial="hidden"
      animate="visible"
      exit="hidden"
      variants={variants}
    >
      <Hint {...props}>{children}</Hint>
    </motion.div>
  );
};

export default styled(AnimatedHintCtrl)`
  user-select: none;
`;
